import { getToken } from '@/utils/auth'

const listeners = new Set()
let socket = null
let reconnectTimer = null
let pingTimer = null
let intentionalClose = false
let retry = 0

function wsURL() {
  const token = encodeURIComponent(getToken() || '')
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${proto}//${window.location.host}/jianguanhui/ws/chat?token=${token}`
}

function emit(payload) {
  listeners.forEach((fn) => {
    try { fn(payload) } catch (e) { /* ignore listener errors */ }
  })
}

function clearTimers() {
  if (reconnectTimer) {
    clearTimeout(reconnectTimer)
    reconnectTimer = null
  }
  if (pingTimer) {
    clearInterval(pingTimer)
    pingTimer = null
  }
}

function scheduleReconnect() {
  if (intentionalClose || !getToken()) return
  if (reconnectTimer) return
  const delay = Math.min(15000, 1000 * Math.pow(2, retry))
  retry += 1
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null
    connect()
  }, delay)
}

export function connect() {
  const token = getToken()
  if (!token) return
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
    return
  }
  intentionalClose = false
  clearTimers()
  try {
    socket = new WebSocket(wsURL())
  } catch (e) {
    scheduleReconnect()
    return
  }

  socket.onopen = () => {
    retry = 0
    pingTimer = setInterval(() => {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: 'ping' }))
      }
    }, 25000)
  }

  socket.onmessage = (ev) => {
    let data
    try {
      data = JSON.parse(ev.data)
    } catch (e) {
      return
    }
    if (!data || !data.type) return
    emit(data)
  }

  socket.onclose = () => {
    socket = null
    clearTimers()
    scheduleReconnect()
  }

  socket.onerror = () => {
    if (socket) {
      try { socket.close() } catch (e) { /* ignore */ }
    }
  }
}

export function disconnect() {
  intentionalClose = true
  clearTimers()
  if (socket) {
    try { socket.close() } catch (e) { /* ignore */ }
    socket = null
  }
}

export function subscribe(fn) {
  listeners.add(fn)
  connect()
  return () => {
    listeners.delete(fn)
  }
}

export function ensureChatSocket() {
  if (getToken()) connect()
  else disconnect()
}
